import { Container } from "react-bootstrap";

const RegulationsScreen = () => {
  return (
    <div
      style={{
        background:
          "linear-gradient(180deg, #F0E6FF 0%, #F5F0FF 30%, #FAFCFF 60%, #FFFFFF 100%)",
        minHeight: "100vh",
        width: "100vw",
        marginLeft: "calc(-50vw + 50%)",
        marginRight: "calc(-50vw + 50%)",
      }}
    >
      <Container>
        <h1
          className="mt-5 text-center pt-5"
          style={{ color: "#6B46C1", fontSize: "32px", marginBottom: "3rem" }}
        >
          תקנון חושבים פלוס
        </h1>

        <div
          style={{
            color: "#333",
            fontSize: "16px",
            lineHeight: "1.6",
            textAlign: "right",
            maxWidth: "800px",
            margin: "0 auto",
          }}
        >
          <h2
            dir="rtl"
            style={{
              color: "#6B46C1",
              fontSize: "24px",
              marginTop: "2rem",
              marginBottom: "1rem",
            }}
          >
            1. כללי
          </h2>
          <p dir="rtl">
            א. השימוש באתר ובתכנים המוצגים בו כפוף לתנאי השימוש המפורטים להלן.
            הנך מתבקש לקרוא תנאים אלו במלואם בעיון רב, שכן תחילת השימוש באתר
            ובתכניו מעידים על הסכמתך ואישורך לכל האמור בתנאי שימוש אלו.
          </p>

          <p dir="rtl">
            ב. כל האמור בלשון רבים גם ביחיד משמעו, וכל האמור בלשון זכר יקרא גם
            כאילו אמור בלשון נקבה.
          </p>

          <p dir="rtl">
            ג. גלישה באתר ו/או רכישת מוצרים באתר, פירושם מתן הסכמתך להיקשר בתנאי
            שימוש אלו.
          </p>

          <p dir="rtl">
            ד. מובהר כי חושבים פלוס שומרת לעצמה את הזכות לשנות תנאים אלו מעת לעת
            ללא צורך במסירת הודעה מראש, להוסיף, לשנות, או לגרוע מתנאים אלו מעת
            לעת, ביחס לאתר כולו, חלקו, למאפיין שלו ו/או ליישום בו. כל שימוש
            באתר, לרבות בתוכן ו/או בשירותיו יהווה הסכמה מחודשת לתנאים ושינויים
            אלה, כפי שיהיו מעת לעת. נוסח תנאי השימוש העדכני יימצא בכל עת באתר
            החברה. מומלץ לעיין בתנאי השימוש בכל כניסה מחודשת לאתר על מנת לעמוד
            על השינויים שחלו.
          </p>

          <p dir="rtl">
            ה. כותרות הפרקים מובאות לשם נוחות והתמצאות בלבד ולא ישמשו בפרשנות
            תנאי השימוש.
          </p>

          <p dir="rtl">
            ו. הרישום לקבלת דיוור אלקטרוני מן האתר וכן השימוש במידע אותו מסר
            המשתמש לחושבים פלוס ו/או שהצטבר אודות המשתמש בעת השימוש באתר, יתבצע
            בהתאם להוראות כל דין ובהתאם למדיניות הפרטיות של האתר, המהווה חלק
            בלתי נפרד מתנאי השימוש.
          </p>

          <p dir="rtl">
            ז. המשתמש מתחייב שלא לעשות במידע או בשירות המוצגים באתר כל שימוש אשר
            אינו בהתאם לדין, הוראות התקנון או מדיניות הפרטיות של חושבים פלוס.
          </p>

          <p dir="rtl">
            ח. התכנים המועלים ומפורסמים באתר או נשלחים באמצעות דיוור אלקטרוני,
            עשויים להיות מוצגים בכל מדיה אחרת, לרבות אתר סלולארי, טלוויזיה או כל
            אמצעי אחר, בין שהינם תחת ניהולה של חושבים פלוס ובין אם לאו, והוראות
            תקנון זה יחולו בקשר עם הצגת התכנים כאמור או השימוש בתכנים לכל צורך
            כאמור.
          </p>

          <p dir="rtl">
            ט. החברה רשאית לחסום גישה אל האתר לצורך עדכונים ושדרוגים, ולשנות,
            מעת לעת, את מבנה האתר, מראה האתר, השירותים והתכנים הניתנים בו, שעות
            הפעילות והציוד הנדרש לצורך גישה ושימוש באתר, וזאת ללא צורך בהודעה
            מראש למשתמש.
          </p>

          <p dir="rtl">
            י. חושבים פלוס רשאית לשנות מעת לעת את תוכן האתר, היקפו, זמינותו
            והשירותים המוצעים בו ללא הודעה מוקדמת ולפי שיקול דעתה הבלעדי, וכל
            שינוי כאמור יחייב את המשתמשים וכן יחול על רכישות שבוצעו באתר, החל
            ממועד פרסום התקנון המעודכן באתר. למשתמשי האתר לא תהא כל טענה או
            תביעה בקשר לשינויים אלו או בקשר עם תקלות שיתרחשו אגב ביצועם.
          </p>

          <h2
            dir="rtl"
            style={{
              color: "#6B46C1",
              fontSize: "24px",
              marginTop: "2rem",
              marginBottom: "1rem",
            }}
          >
            2. קניין רוחני וסימני מסחר
          </h2>

          <p dir="rtl">
            א. מלוא הזכויות מכל מין וסוג שהם, לרבות ומבלי לפגוע בכלליות אמור,
            זכויות היוצרים, כל פטנט, סוד מסחרי, התנהלות עסקית, סימן מסחרי וכל
            זכות קניינית בכל תכנה, הקיימת או שתפותח ו/או תוכנן על-ידי או בעבור
            חושבים פלוס במסגרת או בקשר עם האתר ושירותי חושבים פלוס, תהיינה
            בבעלות הייחודית המלאה והמוחלטת של חושבים פלוס או מי מטעמה.
          </p>

          <p dir="rtl">
            ב. האתר, לרבות אייקונים (icons) כל מידע או תצוגה המופיעים באתר
            ולרבות גרפיקה, עיצוב, הצגה מילולית, סימני מסחר, סימני לוגו (logo)
            וכן עריכתם והצגתם של אלה לרבות השירותים והתכנים שבאתר, כולל טקסט,
            איורים, גרפיקה, צליל, קטעי גרפיקה, קטעי וידאו ומצגות, יישומי תוכנה,
            גרפים ותמונות, הינם רכושה של חושבים פלוס או ניתנו לה ברישיון על ידי
            צדדים שלישים, ומוגנים על ידי חוקי זכויות יוצרים של מדינת ישראל,
            אמנות בינ"ל, וחוקי זכויות יוצרים של מדינות אחרות. כל הזכויות שמורות
            לחושבים פלוס או לצדדים שלישיים, בהתאמה.
          </p>

          <p dir="rtl">
            ג. תקנון זה מעניק למשתמשי האתר הרשאה להשתמש באתר ובשירותיו בלבד,
            ונאסר על המשתמשים לעשות כל פעולה שהיא אשר עלולה לפגוע בזכויות הקניין
            הרוחני הנזכרות לעיל.
          </p>

          <p dir="rtl">
            ד. על המשתמשים באתר החברה חל איסור מוחלט לבצע בו שינויים או להעתיק,
            להפיץ, לשדר, להציג, לבצע, לשכפל, לפרסם, להנפיק רישיון, ליצור עבודות
            נגזרות או למכור פריט מפריטי המידע, התכנים, התוכנה או השירותים שמקורם
            באתר ללא רשות מפורשת של חושבים פלוס בכתב ומראש.
          </p>

          <p dir="rtl">
            ה. החברה אינה אחראית לתכנים פרסומיים המופיעים באתר ו/או בקישורים
            הקיימים באתר החברה אשר מובילים לאתרים אחרים.
          </p>

          <h2
            dir="rtl"
            style={{
              color: "#6B46C1",
              fontSize: "24px",
              marginTop: "2rem",
              marginBottom: "1rem",
            }}
          >
            3. תוכן האתר (קישורים, פורומים, צ'אטים, מידע מסחרי ופרסומות)
          </h2>

          <p dir="rtl">
            א. התכנים והשירותים המצויים באתר (להלן: "התוכן") ניתנים לשימוש
            המשתמשים כפי שהם (As-Is), ומובהר כי לא ניתן להתאימם לצרכיו האישים של
            כל משתמש ומשתמש. למשתמש לא תהיה כל דרישה, טענה או תביעה כלפי חושבים
            פלוס בקשר לטיב התוכן (לרבות בשל תכוניותיו, מגבלותיו, מאפייניו או
            התאמתו למשתמש). כוונת חושבים פלוס היא שהתוכן המופיע באתר יהיה נכון
            ומדויק ככל האפשר ואולם, ייתכן שהתוכן אינו שלם, ולחלופין יתכן שנפלו
            טעויות טכניות, שיבושים ואי-דיוקים וטעויות בתוכן או במידע המובאים
            באתר – לרבות לגבי כל מוצר, שירות או מידע על מבצעים.
          </p>

          <p dir="rtl">
            ב. חושבים פלוס לא תשא בכל אחריות בשל התוכן המובא על ידה באתר או
            בטעויות בו, בגין כל נזק הנגרם למשתמש בפועל, אלא בהתאם לאחריות המוטלת
            עליה לפי דין.
          </p>

          <p dir="rtl">
            ג. תכונות, דגמים, עיצוב, צבעים או חזות של מוצרים המתוארים או מוצגים
            באתר, לרבות כל תמונה או הצגה של מוצר הכלולים באתר, הינם לצורכי המחשה
            בלבד, אלא אם נאמר מפורשות אחרת.
          </p>

          <p dir="rtl">
            ד. תנאיו ותוקפו של כל מבצע ו/או של כל מכירה המפורסמים באתר או
            באמצעות דיוור אלקטרוני שישלח אל הנרשמים לאתר יהיו כפופים לתנאים
            שיקבעו ויפורסמו על ידי חושבים פלוס, ובנוסף למלאי שהוקצב לאותו מבצע
            או לאותה מכירה כמפורסם בדף המוצר. הפריטים המוצגים באתר עומדים למכירה
            בסניפי החברה עד לגמר המלאי או עד למועד מוקדם לכך, לפי שיקול דעתה
            הבלעדי של חושבים פלוס. החברה איננה מתחייבת כי הפריטים המוצגים באתר
            יימצאו בכל אחד מסניפי חושבים פלוס. חושבים פלוס שומרת לעצמה את הזכות
            לשנות את מועד סגירת המכירות או להגדיל את הכמות המוצעת על פי שיקול
            דעתה מבלי שיהיה בכך לפגוע בזכייתם של משתמשים שהצעותיהם נרשמו והתקבלו
            לפני מועד השינוי.
          </p>

          <h2
            dir="rtl"
            style={{
              color: "#6B46C1",
              fontSize: "24px",
              marginTop: "2rem",
              marginBottom: "1rem",
            }}
          >
            4. הגבלת אחריות
          </h2>

          <p dir="rtl">
            א. כל תוכן או מידע המובא באתר בקשר למאפייני המוצר, אשר מקורו בצדדים
            שלישיים, כגון יצרן המוצר, לרבות מפרטים, הוראות הפעלה ונתונים שונים,
            נמסר על ידם ולחברה לא תהיה כל אחריות לגביו.
          </p>

          <p dir="rtl">
            ב. באתר עשויים להיכלל קישורים לאתרי אינטרנט שאינם מופעלים על ידי
            חושבים פלוס, לרבות אתרים של יצרנים, משווקים מורשים ומשווקים שאינם
            מורשים. הקישורים נועדו אך ורק לנוחותם ולידיעתם של המשתמשים. השימוש
            באתרי האינטרנט המקושרים על ידי המשתמש יעשה באחריות המשתמש בלבד
            ובכפיפות לתנאי השימוש ומדיניות הפרטיות של אתרי האינטרנט המקושרים
            כאמור. חושבים פלוס לא תישא באחריות לאתרי האינטרנט המקושרים, לרבות
            לתכניהם, ואין לראות בקישור לאתר כלשהו משום המלצה על אותו אתר.
          </p>

          <p dir="rtl">
            ג. מבלי לגרוע מהאמור לעיל, חושבים פלוס, מנהליה, עובדיה, נציגיה, בעלי
            מניותיה, וכל הפועלים מטעמה ו/או עבורה וכל גורם אחר הקשור באספקת
            השירותים הניתנים באתר לא יהיו אחראים בשום אחריות ו/או חבות לכל נזק
            ו/או פגיעה ו/או הפסד ו/או הוצאה ו/או תשלום, מכל מין וסוג, שייגרמו
            עקב נסיבות מעבר לשליטתם.
          </p>

          <p dir="rtl">
            ד. המשתמש מתחייב לפצות ו/או לשפות את חושבים פלוס, מנהליה, עובדיה,
            נציגיה, בעלי מניותיה, וכל הפועלים מטעמה ו/או עבורה וכל גורם אחר
            הקשור באספקת השירותים הניתנים באתר, מיד עם דרישתם הראשונה, בגין כל
            נזק ו/או פגיעה ו/או הפסד ו/או הוצאה ו/או תשלום שייגרמו להם, מכל מין
            וסוג, לרבות בגין שכ"ט עו"ד והוצאות משפטיות, עקב הפרת תנאי שימוש אלו
            ו/או הוראות החוק על ידי המשתמש, וכן עקב כל טענה ו/או דרישה ו/או
            תביעה שתועלה כנגדם על ידי כל צד שלישי שהוא, בגין הפרה כאמור. למען
            הסר ספק מובהר כי, אחריות המשתמש במקרה של התרחשות איזה מהמקרים
            המפורטים לעיל, כוללת גם נזקים ישירים, עקיפים, תוצאתיים, מקריים או
            מיוחדים, לרבות פגיעה בשם הטוב, פגיעה במוניטין, אבדן הכנסה, אבדן
            נתונים ואבדן רווחים. אין בשיפוי הנ"ל בכדי לגרוע מסעדי חושבים פלוס על
            פי כל דין.
          </p>

          <p dir="rtl">
            ה. חלק מהקישורים שבאתר מובילים למידע ולתכנים המתפרסמים באתרים
            חיצוניים. חושבים פלוס אינה מפרסמת, מעודדת, מסכימה ושולטת במידע
            המתפרסם באתרים חיצוניים אלו ואיננה מפקחת עליהם. חושבים פלוס אינה
            מתחייבת כי הקישורים יובילו לאתר פעיל ותקין והנה רשאית לשנות ולהסיר
            קישורים אלו לפי שיקול דעתה הבלעדי. מובהר כי האמור לעיל, בדבר אי
            אחריותה הכללית של חושבים פלוס , יחול גם על כל המידע אשר מופיע
            בקישורים לאתרי האינטרנט החיצוניים.
          </p>

          <p dir="rtl">
            ו. תוכן אשר מתפרסם באתר במסגרת פורומים וצ'אטים (כמפורט להלן) נכתב על
            ידי משתמשי האתר, ולא על ידי חושבים פלוס או מי מטעמה ועל כן, חושבים
            פלוס אינה יכולה להיות אחראית למהימנותו, אמינותו, דיוקו, שלמותו או
            התאמתו למטרה מסוימת. כמו כן, מובהר כי אין לראות בתוכן זה כעמדה
            מוסמכת ו/או כתחליף לקבלת ייעוץ מקצועי הולם.
          </p>

          <p dir="rtl">
            ז. מובהר כי חושבים פלוס איננה אחראית לתוכן הפרסומות והמידע המסחרי
            המתפרסם באתר. פרסום הפרסומות והמידע המסחרי הנו באחריות המפרסמים
            בלבד, ובשום מקרה איננו מהווה המלצה מטעם חושבים פלוס להשתמש /ואו
            לרכוש את המוצרים/השימושים המוצעים באתר.
          </p>

          <p dir="rtl">
            ח. חושבים פלוס אינה מתחייבת שהשירות הניתן באתר לא יופרע, יינתן כסדרו
            ללא הפסקות והפרעות ו/או יהא חסין מפני גישה לא חוקית, נזקים, קלקולים,
            תקלות, כשלים בחומרה, תוכנה או בקווי התקשורת אצל חושבים פלוס ו/או מי
            מספקיה או ייפגע מכל סיבה אחרת, וחושבים פלוס לא תהא אחראית לכל נזק -
            ישיר או עקיף - עגמת נפש וכיו"ב, שייגרמו למשתמשי האתר או לרכושם עקב
            כך.
          </p>

          <p dir="rtl">
            ט. חושבים פלוס שומרת לעצמה את הזכות למסור לאחרים, בכל עת, כל מידע
            אשר ידרש ממנה על פי החוק, כמו גם את הזכות לערוך, להסיר, לסרב להעלות
            לאתר כל מידע או תוכן שלפי שיקול דעתה הבלעדי פוגע ו/או מפר את האמור
            בתנאי שימוש אלו. משתמשי האתר מתחייבים בזאת כי לא יפרסמו, יעלו,
            ישדרו, ישלפו, ימכרו, יעתיקו, יפרסמו או יפיצו מהאתר או אליו בין
            בתמורה ובין שלא בתמורה תוכן או מידע כלשהם ללא הסכמתה המפורשת בכתב
            ומראש של חושבים פלוס . המשתמש יפצה את חושבים פלוס , מיד עם דרישתה
            הראשונה, בגין כל תביעה ו/או דרישה שהוגשה בקשר לתכנים שהוזנו על ידו
            לאתר. חל איסור להזין לאתר תכנים או מידע אשר עלולים להצטייר כתכנים
            האסורים לפרסום מאחר והנם, בין היתר, בגדר איום, העלבה, פגיעה, השמצה,
            הוצאת דיבה, הטרדה מינית, גזענות, פורנוגרפיה, פגיעה ברגשות ובאמונות
            הציבור; תכנים ומידע אשר עלולים למנוע מאחרים את השימוש באתר; תכנים
            העלולים להפר זכות קניינית כלשהי של אחר, לרבות אך לא רק זכויות קניין
            רוחני, זכויות יוצרים, זכויות להגנת הפרטיות ופטנט; תכנים ומידע
            העלולים לחבל במערכות מחשב; תכנים הכוללים בחובם פרסומת מכל סוג שהוא
            ללא הרשאה מפורשת בכתב ומראש של חושבים פלוס ; תכנים ומידע אשר עלולים
            לעודד ולסייע לאחר לבצע מעשה האסור על פי החוק או שעלול לגרור אחריו
            אחריות משפטית.
          </p>

          <p dir="rtl">
            י. כל משתמש באתר ושירותיו הנו האחראי הבלעדי לתוכן הודעות הדואר
            האלקטרוני, ההודעות הכתובות וכל מסר או נתון אחר הנמסר על ידו, לרבות
            נתונים שישלב במאגר לשימוש אישי שלו, ולתוצאות שינבעו מאלו. המשתמש
            מתחייב שלא להשתמש בשירותי האתר למטרות דיוור שרשרת, דיור פרסומי או כל
            שימוש אחר אשר עשוי להתפרש כבלתי חוקי, מאיים, גס, טורדני וכדומה.
            בנוסף, מתחייב משתמש האתר שלא להשתמש בשירותי האתר ו/או בתוכן למטרות
            מסחריות אלא לאחר קבלת אישור לכך מראש ובכתב על ידי חושבים פלוס .
          </p>

          <p dir="rtl">
            יא. למרות האמור לעיל, וככל שיקבע כי חושבים פלוס אחראית לנזק כלשהו,
            אזי סך כל הנזקים בהם תחויב במסגרת האחריות לא יעלה על שווי המוצר מושא
            האחריות.
          </p>

          <h2
            dir="rtl"
            style={{
              color: "#6B46C1",
              fontSize: "24px",
              marginTop: "2rem",
              marginBottom: "1rem",
            }}
          >
            5. הפסקת שימוש
          </h2>

          <p dir="rtl">
            א. חושבים פלוס תהא רשאית לסרב להעניק ולחסום למשתמש גישה לאתר
            ולשירותים או לחלק מהם, לרבות למאגר הנתונים לשימוש אישי, וכן להפסיק
            את חברותו של משתמש או את הרשאתו להשתמש בשירות או באתר לרבות חסימת שם
            משתמש בדואר אלקטרוני, סילוק מפורומים, אי-פרסום טוקבקים וכדומה, לפי
            שיקול דעתה הבלעדי וללא התראה מוקדמת, ולמשתמש לא תהיה טענה כנגדה וזאת
            במקרה בו לא יעמוד המשתמש בתנאי מתנאֵי הסכם זה. היה ויפר משתמש תנאי
            שימוש אלה, תהא חושבים פלוס, לפי שיקול דעתה, רשאית לחשוף את שמו
            והפרטים הידועים לה אודותיו בכל הליך משפטי, אף אם לא יינתן צו שיפוטי
            המורה על כך.
          </p>

          <p dir="rtl">
            ב. במקרה כאמור לעיל, ישפה המשתמש את חושבים פלוס ו/או מי מטעמה בגין
            כל נזק, הפסד, אבדן או הוצאה שייגרמו לה, עקב הפרת תנאי שימוש אלה.
          </p>

          <h2
            dir="rtl"
            style={{
              color: "#6B46C1",
              fontSize: "24px",
              marginTop: "2rem",
              marginBottom: "1rem",
            }}
          >
            6. מדיניות פרטיות
          </h2>

          <p dir="rtl">
            א. חושבים פלוס מכבדת את פרטיותם של המשתמשים הנכנסים לאתר ו/או
            המשתמשים בשירותים השונים המוצעים במסגרתו. לפיכך, מנהיגה חושבים פלוס
            מדיניות פרטיות, כפי שתוצג באתר, אשר מטרתה להציג את האופן שבו היא
            משתמשת במידע שנמסר לה על ידי המשתמשים באתר ו/או נאסף על ידה בעת
            השימוש באתר וכן את האופן שבו מבצע המשתמש שימוש בתוכן המצוי באתר ו/או
            אליו נחשף המשתמש באמצעותו.
          </p>

          <p dir="rtl">
            ב. תנאי מדיניות הפרטיות המפורטים באתר, מהווים חלק בלתי נפרד מן
            התקנון ותנאי השימוש. חושבים פלוס רשאית לשנות מעת לעת, ועל דעתה בלבד,
            את הוראות מדיניות הפרטיות שלה, כדי שישקפו שינויים טכנולוגיים,
            עסקיים, משפטיים או רגולטורים.
          </p>

          <h2
            dir="rtl"
            style={{
              color: "#6B46C1",
              fontSize: "24px",
              marginTop: "2rem",
              marginBottom: "1rem",
            }}
          >
            7. רישום
          </h2>

          <p dir="rtl">
            א. במסגרת השירותים שמציעה חושבים פלוס למשתמשי האתר, ובכלל זה ביצוע
            פעולות מסוימות, קבלת פרסומים או מבצעים, תיתכן דרישה לביצוע הרשמה
            במהלכה יידרש המשתמש למסור מידע אישי, כדוגמת שם, כתובת, דרכי ההתקשרות
            או כתובת דואר האלקטרוני. השדות, שחובה למלא, יסומנו במפורש. יובהר כי
            בלי למסור את הנתונים המתבקשים בשדות החובה לא יוכל משתמש להירשם
            לשירותים הטעונים רישום (להלן: "ההרשמה"). כחלק בלתי נפרד מהליך ההרשמה
            לאתר וכתנאי לסיום תהליך הרישום, תהא חושבים פלוס רשאית לאמת את זהותו
            של המשתמש בהתאם למידע שנמסר לה על ידו.
          </p>

          <p dir="rtl">
            ב. מילוי חלק מהשדות בהליך הרישום לאתר מהווה תנאי הכרחי לשימוש לסיום
            הליך ההרשמה. המשתמש מצהיר ומתחייב בזאת, כי כל המידע שימסור ו/או
            יעדכן באתר, הנו נכון אמין ומדויק וכן כי ביצע את ההרשמה או מסר את
            המידע בשמו ועבור עצמו בלבד ולא בשם או עבור צדדים שלישיים, למעט
            במקרים בהם הורשה לעשות כן, במפורש ועל פי דין. המידע שמסר המשתמש וכן
            מידע נוסף שיצטבר אודותיו ישמרו במאגר המידע של החברה ויעשה בו שימוש
            בהתאם למדיניות הפרטיות של חושבים פלוס ובהתאם להוראות כל דין.
          </p>

          <p dir="rtl">
            ג. מובהר בזאת, כי לא חלה על המשתמש כל חובה שבדין למסור את המידע
            כאמור וכן שמסירת המידע תלויה ברצונו ובהסכמתו של המשתמש. הרישום באתר
            באמצעות סימון "הסכמה לקבלת דיוור אלקטרוני" יהווה הסכמה אקטיבית
            ופוזיטיבית מטעם המשתמש לקבלת חומר פרסומי ושיווקי חושבים פלוס או
            גורמים אחרים אשר יעניקו לחברה שירותים או הטבות, באמצעי המדיה השונים
            לרבות באמצעות דיוור ישיר.
          </p>

          <p dir="rtl">
            ד. משתמש שנרשם באתר זכאי לבקש מהחברה בכל עת, בהודעה בכתב למען החברה,
            בהודעה פקס או במשלוח אימייל, שהמידע המתייחס אליו יימחק ממאגר המידע
            של החברה וכי ברצונו למחוק את רישומו ברשימת הדיוור של חושבים פלוס.
            במקרה זה חושבים פלוס תהא רשאית, בהתאם ובכפוף להוראות הדין החל,
            להיענות לבקשתו.
          </p>

          <p dir="rtl">
            ה. המשתמש מסכים בזאת באופן מפורש לשימוש האמור לעיל במידע ומאשר כי
            השימוש בו לא ייחשב כפגיעה בפרטיות המשתמש ולא יזכה אותו בכל סעד ו/או
            פיצוי כלשהו.
          </p>

          <p dir="rtl">
            ו. בכל מקרה של ביטול רישום, יבוטל הרישום החל מתחילת החודש הקלנדרי
            העוקב שלאחר מסירת הודעה בנושא.
          </p>

          <h2
            dir="rtl"
            style={{
              color: "#6B46C1",
              fontSize: "24px",
              marginTop: "2rem",
              marginBottom: "1rem",
            }}
          >
            8. תנאי שימוש בחנות האתר
          </h2>

          <h3
            dir="rtl"
            style={{
              color: "#6B46C1",
              fontSize: "20px",
              marginTop: "1.5rem",
              marginBottom: "1rem",
            }}
          >
            8.1. המוצרים המוצעים למכירה
          </h3>

          <p dir="rtl">
            א. באתר מוצגים מגוון רחב של מוצרים ושירותים (להלן: ''המוצרים'') מאת
            מיטב היצרנים והמשווקים.
          </p>

          <p dir="rtl">
            ב. בדף המכירה של כל מוצר, מופיעים פרטי ונתוני המוצר, והתנאים
            למכירתו. חושבים פלוס עושה מאמצים רבים לספק תאור ומידע עדכני ומקיף על
            המוצרים המוצעים למכירה באתר, ואף הפניות לאתרי יצרנים ואתרים המציעים
            מידע שימושי נוסף. עם זאת, במידה וישנו קישור (''לינק'') באתר חושבים
            פלוס, המפנה לאתרים אחרים, לא תישא חושבים פלוס באחריות לתוכנם של אותם
            אתרים, למידע המתפרסם בהם או לכל פרט אחר הקשור עמם, ולא תהיה אחראית
            לכל נזק ישיר או עקיף שייגרם או עלול היה להיגרם, כתוצאה משימוש או
            הסתמכות על המידע המופיע בשירותים אליהם הנך עשוי להגיע באמצעות הקישור
            באתר חושבים פלוס.
          </p>

          <p dir="rtl">
            ג. תמונות המוצרים באתר נועדו להמחשה בלבד, וייתכנו הבדלים בין התמונה
            לבין המוצר הנמכר, הן בשל מגבלות המדיה האלקטרונית (העברת צבעים,
            גוונים וכיו"ב), או שינויים הנערכים במוצרים מעת לעת.
          </p>

          <h3
            dir="rtl"
            style={{
              color: "#6B46C1",
              fontSize: "20px",
              marginTop: "1.5rem",
              marginBottom: "1rem",
            }}
          >
            8.2. הזמנת פריטים
          </h3>

          <p dir="rtl">
            א. לאחר שביצעת את ההזמנה תקבל הודעה ראשונית על קליטת פרטי הזמנתך.
            לתשומת לבך: אישור זה אינו מחייב את החברה ו/או מי מטעמה לספק את
            המוצרים שהזמנת, והוא רק מעיד שפרטי ההזמנה נקלטו במערכת.
          </p>

          <p dir="rtl">
            ב. רק לאחר שהחברה ו/או מי מטעמה תסיים לבדוק את פרטי כרטיס האשראי
            שלך, ויתקבל אישור חברת כרטיסי האשראי לביצוע הרכישה, תיחשב הצעתך כברת
            ביצוע ויתחילו כל תהליכי אספקת המוצרים שהזמנת, בתנאי שפרטי הזמנתך
            נקלטו במערכת ללא שיבוש, ובלבד שהמוצר נמצא במלאי. במקרה בו המוצר
            המוצג באתר אשר הוזמן על ידך אזל מהמלאי, תשלח לך הודעה מתאימה באמצעות
            הדואר האלקטרוני שלך ו/או באמצעות הטלפון ככל שהוזן על ידך באתר.
          </p>

          <p dir="rtl">
            ג. ככל שהמוצר אותו בחרת אינו נמצא במלאי, האתר שומר לעצמו את הזכות
            להגיש לך הצעה לרכישת מוצר חלופי בעל אופי ומחיר דומים, במידה וקיימת
            חלופה כזו. אם תקבל את הצעת האתר ותהיה מעוניין לרכוש את המוצר החלופי
            - יעודכנו פרטי הזמנתך מחדש. לעומת זאת, אם החלטת לסרב להצעת האתר -
            תימחק הזמנתך ולא יבוצע חיוב כרטיס האשראי שמסרת.
          </p>

          <h3
            dir="rtl"
            style={{
              color: "#6B46C1",
              fontSize: "20px",
              marginTop: "1.5rem",
              marginBottom: "1rem",
            }}
          >
            8.3. שיבושים בהזמנה
          </h3>

          <p dir="rtl">
            א. על מנת לספק לך את המוצרים שהזמנת, נדרשת הזמנתך להתקבל ולהיקלט
            אצלנו באופן תקין ומסודר, כשהיא מכילה את כל הפרטים הנדרשים למשלוח
            המוצרים ולחיוב רכישתם. יתכנו סיבות שונות עלולות לגרום לתקלות
            ולשיבושים בקליטת ההזמנה ועיבודה על ידי החברה ו/או האתר. ככל שתקבל
            הודעה בדבר תוכן שגוי בפרטי הזמנתך או הודעה בדבר תקלה שארעה במערכת או
            ככל שיחול שיבוש ו/או טעות בתיאור המוצר ו/או השירות, בתמונתם, תיאורם,
            מחירם או בכל פרט אחר, יהיה האתר רשאי לבטל את רכישתך ואת/ה לא תחויב
            בכל תשלום בגין ההזמנה שבוטלה.
          </p>

          <p dir="rtl">
            ב. ככל שבעת ביצוע ההזמנה תמסור פרטי זיהוי שגויים, לא נוכל להבטיח
            שהמוצרים יגיעו אליך. במקרה שהמוצרים יחזרו אלינו בגלל פרטים מוטעים
            שמסרת - תחויב בתשלום בגין דמי טיפול ומשלוח. אנא הקפד למלא פרטים
            מדויקים ועדכניים.
          </p>

          <p dir="rtl">
            ג. הזנת פרטים אישיים כוזבים אסורה לחלוטין ומהווה עבירה פלילית על פי
            הוראות חוק העונשין, התשל"ז - 1977 ו/או בכל דין אחר.
          </p>

          <h3
            dir="rtl"
            style={{
              color: "#6B46C1",
              fontSize: "20px",
              marginTop: "1.5rem",
              marginBottom: "1rem",
            }}
          >
            8.4. אמצעי התשלום
          </h3>

          <p dir="rtl">
            א. תשלום עבור הזמנת המוצרים יתבצע באמצעות כרטיס אשראי תקף או חשבון
            Paypal.
          </p>

          <p dir="rtl">
            ב. את מספר כרטיסך ופרטיו תידרש להזין במקום המיועד לכך. בכל מקרה בו
            תסרב חברת כרטיסי האשראי או הסליקה לאפשר לאתר לגבות את התמורה, ייחשב
            הדבר כביטול ההזמנה על ידי הקונה ויחולו על כך כל התנאים האמורים להלן
            לגבי ביטול העסקה על ידי הקונה.
          </p>

          <h2
            dir="rtl"
            style={{
              color: "#6B46C1",
              fontSize: "24px",
              marginTop: "2rem",
              marginBottom: "1rem",
            }}
          >
            9. אספקה
          </h2>

          <p dir="rtl">
            א. אספקת המוצרים ושליחתם תתבצע תוך 5 ימי עסקים בישובים בהתאם לרשימת
            המפורטת במדיניות המשלוחים באתר. חישוב מועדי האספקה יהיה על פי ימי
            עסקים, דהיינו חמישה ימי עבודה בשבוע, ימים א'- ה', ואינו כולל ימי
            שישי, שבת, ערבי חגים ומועדים. בנוסף, לא ייכלל יום ההזמנה לצורך מניין
            ימי העסקים לאספקת המוצרים, אם נעשתה לאחר השעה 12:00. יחד עם זאת,
            חושבים פלוס עושה כמיטב יכולתה להקדים את זמן האספקה.
          </p>

          <p dir="rtl">
            ב. לחילופין, תוכל לבחור בעת ביצוע ההזמנה באפשרות לאיסוף עצמי מאחת
            מנקודות החלוקה של חושבים פלוס בישראל, על פי בחירתך בכפוף להימצאותו
            של המוצר שהוזמן במלאי.
          </p>

          <p dir="rtl">
            ג. לחילופין, תוכל לבחור בעת ביצוע ההזמנה באפשרות למשלוח מהיר כמפורט
            במדיניות המשלוחים באתר.
          </p>

          <p dir="rtl">
            ד. משלוח המוצרים ואספקתם יעשו אך ורק בהתאם למדיניות הקבועה במסמך זה
            ובכפוף לשיקול דעתה של חושבים פלוס. לחושבים פלוס שמורה הזכות להודיע
            כי אין באפשרותה להוביל את המוצר לאזור מסוים, ובמקרה זה לא תחויב בדמי
            משלוח. ככל ועדיין תהיה מעוניין לרכוש את המוצר, אספקת המוצר לידיך
            תתבצע באחת מנקודות החלוקה של חושבים פלוס בישראל כפי שיבחר על ידך
            במועד ההזמנה ובכפוף להימצאותו של המוצר במלאי. עיכוב בשליחת המוצר על
            ידי חושבים פלוס, או חברת דואר ישראל בע"מ לא תהווה עילה לתביעה ואין
            הלקוח זכאי לתבוע כל פיצוי על כל נזק ישיר או עקיף מעבר לשווי העסקה
            עצמה.
          </p>

          <p dir="rtl">
            ו. במידה שבחרת באספקת המוצר ו/או השירות באמצעות משלוח, הם יסופקו
            לכתובת שמסרת לנו במהלך תהליך הרכישה באתר באמצעות שליח. אנו מנועים
            מאספקת משלוחים, בכל דרך שהיא, לכתובת שהיא ת.ד.
          </p>

          <p dir="rtl">
            ז. בעת האספקה, רשאית חושבים פלוס לבקש את נוכחותך במקום ובמועד
            האספקה, והצגת תעודת זהות שלך ו/או חתימתך על גבי שובר כרטיס האשראי
            ו/או קופון, כתנאי למסירה. במידה שמוצר לא יישלח אליך בתוך 14 ימי
            עסקים ממועד המשלוח שצוין באתר, תהיה זכאי לבטל את העסקה ולקבל חזרה את
            מלוא התמורה ששולמה בעד אותו המוצר. עם ביטול העסקה כאמור, וקבלת
            התמורה בחזרה, לא תהא לך כל טענה או תביעה כלפי האתר ובקשר עם העסקה.
          </p>

          <p dir="rtl">
            ח. ידוע לך כי בכל מקרה בו לא יעלה בידי האתר ו/או חושבים פלוס ליצור
            עמך קשר במקרה הצורך לשם השלמת ההזמנה ו/או אספקת המוצר, בתוך 5 ימים
            מיום ביצוע הרכישה, ייחשב הדבר כביטול הרכישה על ידך. במקרה זה לא יהיה
            על האתר לספק לך את המוצר, ואף לא תהיה לך כל טענה ו/או תביעה כלפי
            האתר, בגין ביטול העסקה על פי סעיף זה.
          </p>

          <p dir="rtl">
            ט. במקרה של הובלה חריגה, על פי שיקול דעתה הבלעדי של חושבים פלוס או
            מי מטעמה (כגון הובלה שלא ניתן לבצעה באמצעות מדרגות או מעלית, הובלה
            שנדרש מכשור מיוחד לביצועה או הובלה לקומות גבוהות), תחול כל עלות
            ההובלה, במלואה, על הלקוח.
          </p>

          <h2
            dir="rtl"
            style={{
              color: "#6B46C1",
              fontSize: "24px",
              marginTop: "2rem",
              marginBottom: "1rem",
            }}
          >
            10. מחירים ותשלומים
          </h2>

          <p dir="rtl">
            א. חיובך יתבצע באמצעות כרטיס האשראי שאת פרטיו מסרת בעת ההזמנה באתר
            או בטלפון או באמצעות חשבון Paypal שהוזן על ידך, במחיר שמופיע באתר
            בסמוך למוצרים שהזמנת, בתוספת הוצאות המשלוח ודמי הטיפול, והכל כמפורט
            בסמוך לכל מוצר ו/או בדף המוצר, ובסיכום תהליך ההזמנה.
          </p>

          <p dir="rtl">
            ב. חושבים פלוס רשאית לשנות את מחירי המוצרים ואת דמי הטיפול והמשלוח
            מעת לעת. המחיר התקף ביחס להזמנה שביצעת, הוא המחיר שיתפרסם באתר בעת
            ההזמנה אישור חברת כרטיסי האשראי או הסליקה לחיוב.
          </p>

          <p dir="rtl">
            ג. מחירי המוצרים ו/או השירותים ודמי הטיפול והמשלוח המופיעים באתר -
            כוללים מע"מ, אלא אם כן צוין אחרת.
          </p>

          <p dir="rtl">
            ד. במידה שהזמנת מוצר ו/או שירות באתר וקיימת אפשרות לשלם תמורתו
            בתשלומים - דמי הטיפול והמשלוח לא יחושבו במניין התשלומים, ויחויבו
            בתשלום הראשון של המוצר.
          </p>

          <p dir="rtl">
            ה. במקרה שחברת כרטיסי האשראי או חברת הסליקה תסרב לכבד את התשלום,
            תבוטל הזמנתך, והמוצר לא יסופק לך.
          </p>

          <h2
            dir="rtl"
            style={{
              color: "#6B46C1",
              fontSize: "24px",
              marginTop: "2rem",
              marginBottom: "1rem",
            }}
          >
            11. ביטול עסקה והחזרת מוצרים
          </h2>

          <p dir="rtl">
            א. משתמש שבחר לרכוש מוצר (להלן: "הרוכש") באתר מחויב לבדוק את המוצר
            שרכש מיד עם קבלתו.
          </p>

          <p dir="rtl">
            ב. כל רוכש רשאי להחזיר או להחליף מוצר בהתאם להוראות תקנון והוראות
            מדיניות להחזרת מוצרים, בהתאם להוראות חוק הגנת הצרכן, התשמ"א-1981 וכן
            תקנות הגנת הצרכן (ביטול עסקה), התשע"א-2010 (להלן ביחד: "החוק").
          </p>

          <p dir="rtl">
            ג. בכל מקרה של ביטול עסקה, יציג הצרכן חשבונית או סרט קופה או פתק
            החלפה המעידים על עצם ביצוע העסקה עם חושבים פלוס או הוכחה אחרת,
            לשביעות רצון חושבים פלוס, לגבי עצם ביצוע העסקה, מועדה, הסכום ששולם
            בעדה ואמצעי התשלום.
          </p>

          <p dir="rtl">
            ד. במקרה של מוצר פגום, תתבקש ליצור קשר עם שירות הלקוחות של חושבים
            פלוס בצירוף חשבונית הקניה שקיבלת. במידה שהמוצר תקין ולא עבר זמן
            ההחלפה בהתאם להוראות החוק ובלבד שהמוצר נמצא במלאי אצל הספק, יחליף לך
            את המוצר.
          </p>

          <p dir="rtl">
            ה. בביטול עסקה עקב פגם או אי התאמה במוצר, תחזיר חושבים פלוס בתוך 14
            ימים מיום קבלת הודעת הביטול, את אותו חלק ממחיר העסקה ששולם על ידי
            הרוכש, תבטל את החיוב בשל העסקה, תמסור עותק מהודעת ביטול החיוב ולא
            תגבה מהרוכש סכום נוסף כלשהו. אם סופק לך המוצר – תתבקש להחזירו על
            חשבונך, לרבות באמצעות משלוח בדואר רשום לכתובת שתוגדר על ידי חושבים
            פלוס.
          </p>

          <p dir="rtl">
            ו. במקרה של ביטול עסקה שלא עקב פגם או אי התאמה במוצר תחזיר חושבים
            פלוס בתוך 14 ימים מיום קבלת הודעת הביטול, את אותו חלק ממחיר העסקה
            ששולם, ככל ששולם, תבטל את החיוב בשל העסקה, תמסור עותק מהודעת ביטול
            החיוב ולא תגבה מהלקוח סכום כלשהו, למעט דמי טיפול בסך 5% מערך העסקה
            או 100 ₪, לפי הנמוך מביניהם וזאת מבלי לגרוע מיתר זכויותיה בהתאם
            להוראות החוק. עלות ההחזרה חלה על הרוכש ותשולם על ידו.
          </p>

          <p dir="rtl">
            ז. החזרת המוצר וביטול העסקה תתאפשר באמצעות יצירת קשר עם שירות
            הלקוחות של חושבים פלוס, בצירוף חשבונית הקניה, לאחר שהמוצר נבדק על
            ידי חושבים פלוס או מי מטעמה ונמצא שלא נעשה בו כל שימוש, והוא באריזתו
            המקורית, לרבות כל מרכיבי המוצר והאריזה.
          </p>

          <p dir="rtl">
            ח. החזרת התמורה ואופן החזרת התמורה במקרה של ביטול עסקה תהיה בהתאם
            להוראות החוק ובכפוף לאמור לעיל, לרבות בסעיף 6 לעיל.
          </p>

          <h2
            dir="rtl"
            style={{
              color: "#6B46C1",
              fontSize: "24px",
              marginTop: "2rem",
              marginBottom: "1rem",
            }}
          >
            12. אחריות
          </h2>

          <p dir="rtl">
            א. חושבים פלוס ו/או מי מטעמה אינם מייצרים את המוצרים ואינם נושאים
            באחריות לטיב המוצרים, לתכונותיהם, לשמות היצרנים ו/או לכל מצג שנעשה
            באתר בכל הנוגע לפרטים האמורים, אלא בהתאם לאחריות המוטלת עליהם לפי
            דין. המוצרים באתר מוצגים בתום לב, ומתוארים על ידנו בצורה
            אובייקטיבית, תוך הישענות על פרטים שנמסרו על ידי היצרן, ניסיון בשימוש
            וחוות דעת קונים וגולשים. אין לראות בהצגתם משום המלצה מצד האתר לגבי
            אופיים של המוצרים, תכונותיהם, טיבם, שמות היצרנים וכיו"ב.
          </p>

          <p dir="rtl">
            ב. האחריות הבלעדית למוצרים, לאספקתם, לאיכותם, לטיבם, לעמידותם
            ולתכולתם, לרבות הוראות הפעלה בשפה העברית, חלה על היצרנים ו/או
            היבואנים של המוצרים ובהתאם לתנאים המופיעים על תעודת האחריות, ככל
            שקיימת ושמצורפת אליהם. בכל מקרה, ותחת כל עילה משפטית שהיא, החבות
            בגין מוצרים הנמכרים באתר, תהא על פי דין, ולא תעלה מעבר לגובה התמורה
            ששולמה בפועל על המוצר או השירות שהוזמנו על ידי הרוכש.
          </p>

          <p dir="rtl">
            ג. חושבים פלוס ו/או מי מטעמה לא יישאו בכל אחריות לכל שימוש בלתי
            מורשה, שימוש לרעה, שימוש שלא כדין ו/או שימוש במרמה שייעשה על ידי צד
            שלישי בכרטיס האשראי בו עשית שימוש לשם ביצוע פעולה באתר.
          </p>

          <h2
            dir="rtl"
            style={{
              color: "#6B46C1",
              fontSize: "24px",
              marginTop: "2rem",
              marginBottom: "1rem",
            }}
          >
            13. שונות
          </h2>

          <p dir="rtl">
            א. כל ויתור של חושבים פלוס על קיום זכות המגיעה לה על פי תנאי שימוש
            אלו ו/או על פי דין, או הימנעותה של חושבים פלוס מעמידה על זכותה, לא
            יחשבו כויתור, הימנעות או היווצרות נוהג לגבי מקרים אחרים.
          </p>

          <p dir="rtl">
            ב. כל פטור ו/או העדר אחריות המוקנה לחושבים פלוס על פי הוראות תנאי
            השימוש מוקנה בזאת גם למנהליה, עובדיה, נציגיה, בעלי מניותיה, וכל
            הפועלים מטעמה ו/או עבורה, וכן כל גורם אחר הקשור באספקת השירותים
            המוצרים והתכנים, כפי שאלו יהיו מעת לעת.
          </p>

          <p dir="rtl">
            ג. רישומי המחשב של חושבים פלוס בדבר הפעולות המתבצעות דרך האתר יהוו
            ראיה לכאורה לנכונות הפעולות.
          </p>

          <p dir="rtl">
            ד. הדין החל על השימוש באתר ובשירותיו, ולרבות על תנאי שימוש אלה, הנו
            הדין הישראלי בלבד, בין שהשימוש בשירותים ובתכנים נעשה בישראל ובין
            שמחוצה לה. בתי המשפט המוסמכים בתל-אביב-יפו בישראל תהיה סמכות השיפוט
            הבלעדית לדון בכל מקרה של סכסוך או מחלוקת בקשר עם נושאי הסכם זה ו/או
            בקשר עם השירותים והתכנים. אין בהוראת סעיף זה כדי למנוע מחושבים פלוס
            ו/או מי מטעמה, על פי שיקול דעתה הבלעדי, לנקוט בהליך משפטי כנגד
            משתמש, מחוץ לגבולות מדינת ישראל.
          </p>

          <h2
            dir="rtl"
            style={{
              color: "#6B46C1",
              fontSize: "24px",
              marginTop: "2rem",
              marginBottom: "1rem",
            }}
          >
            14. יצירת קשר
          </h2>

          <p dir="rtl">
            בכל שאלה ו/או הבהרה ו/או תגובה בנוגע לתקנון זה אנא שלח דואר אלקטרוני
            לכתובת hoshvim-plus@gmail.com. בכל תכתובת לחברה יש לכלול את פרטיך
            המלאים לרבות, כתובת ואי מייל ליצירת קשר. חושבים פלוס תשתדל להגיב לכל
            בקשה סבירה בזמן סביר.
          </p>

          <div style={{ paddingBottom: "3rem" }}></div>
        </div>
      </Container>
    </div>
  );
};

export default RegulationsScreen;
